import LoopFront from 'loop-front'

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish'
}

export class BookModel extends LoopFront<{}, {}, typeof CustomActivities> {
    constructor() {
        super('books', {}, {}, CustomActivities);
    }
}

export const OBook = new BookModel();